import { toast } from "react-toastify";
import { isString } from "lodash";
import { resolveBackendErrorCode, translateBackendError } from "../utils/backendErrorMessage";
import {
	isPaymentMethodRequiredError,
	openCloudPaymentRequiredDialog,
} from "../utils/openCloudPaymentRequiredDialog";

const toastError = (err) => {
	if (!err) {
		console.error("Error indefinido recibido en toastError");
		toast.error("Error inesperado");
		return;
	}

	const toastConfig = {
		autoClose: 4000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: true,
		progress: undefined,
		theme: "light",
	};

	const responseData = err.response?.data;
	const errorCode = resolveBackendErrorCode(err);
	const translated = translateBackendError(err);
	const statusCode = responseData?.statusCode || err.response?.status;

	if (isPaymentMethodRequiredError(errorCode)) {
		openCloudPaymentRequiredDialog();
		return;
	}

	if (translated) {
		toast.error(translated, {
			...toastConfig,
			toastId: `${statusCode || "err"}-${errorCode || translated}`,
		});
		return;
	}

	if (responseData && isString(responseData)) {
		toast.error(responseData, toastConfig);
		return;
	}

	if (err.message) {
		toast.error(err.message, toastConfig);
		return;
	}

	console.error("Error detallado:", err);
	toast.error("Error inesperado", toastConfig);
};

export default toastError;
